import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectHopTimusEnabled } from '@/containers/Login/AuthSelectors'
import { useRightPanelHopTimus } from '../rightPanelContext'

const useHopTimusRailEntry = () => {
  const { t } = useTranslation()
  const enabled = useSelector(selectHopTimusEnabled)
  const { mode, toggle, dock } = useRightPanelHopTimus()

  return {
    hidden: !enabled,
    label: t('common:hop_timus_button'),
    hoverLabel: `${t('common:hop_timus_button')} (${t('common:hop_timus_shortcut')})`,
    open: mode === 'docked',
    onClick: mode === 'floating' ? dock : toggle,
  }
}

export default useHopTimusRailEntry
